import React from 'react';
import PropTypes from 'prop-types';

const RouteParameter = ({ params, fallback, children, location }) => {
  const urlSearchParams = new URLSearchParams(location.search);
  const shouldFallback = params.find((key) => !urlSearchParams.get(key));

  if (shouldFallback && params.length > 0) {
    return fallback;
  }
  return <>{children}</>;
};

RouteParameter.propTypes = {
  params: PropTypes.arrayOf(PropTypes.string),
  // eslint-disable-next-line react/forbid-prop-types
  location: PropTypes.object.isRequired,
  fallback: PropTypes.element,
  children: PropTypes.element,
};

RouteParameter.defaultProps = {
  params: [],
  fallback: undefined,
  children: undefined,
};

export default RouteParameter;
